import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { SUBSCRIPTION_ENDPOINTS, STORAGE_KEYS } from '../../constants/api';
import styles from '../../styles/Subscription.module.css';

const Subscription: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleUpgrade = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = sessionStorage.getItem(STORAGE_KEYS.TOKEN);
      const { data } = await axios.post(
        SUBSCRIPTION_ENDPOINTS.CREATE_PAYMENT,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Build a hidden form and submit it to PayFast
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = data.payfastUrl;
      Object.entries(data.params).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = String(value);
        form.appendChild(input);
      });
      document.body.appendChild(form);
      form.submit();
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || 'Failed to initiate payment. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className={styles.subscriptionPage}>
      <div className={styles.container}>
        <h1>Upgrade Your Subscription</h1>
        <p className={styles.subtitle}>
          Continue enjoying all the features of Realty Genie
        </p>

        <div className={styles.pricingCard}>
          <div className={styles.cardHeader}>
            <h2>Premium Plan</h2>
            <div className={styles.price}>
              <span className={styles.currency}>R</span>
              <span className={styles.amount}>299</span>
              <span className={styles.period}>/month</span>
            </div>
          </div>

          <div className={styles.features}>
            <h3>What's Included:</h3>
            <ul>
              <li>✅ Unlimited document uploads</li>
              <li>✅ PPRA audit-ready compliance</li>
              <li>✅ FICA verification management</li>
              <li>✅ POPIA data security</li>
              <li>✅ Transaction management</li>
              <li>✅ Client database</li>
              <li>✅ Agency user management</li>
              <li>✅ Priority support</li>
              <li>✅ Regular compliance updates</li>
            </ul>
          </div>

          <div className={styles.actions}>
            {error && <p style={{ color: '#dc2626', fontSize: 14, marginBottom: 12 }}>{error}</p>}
            <button 
              className={styles.upgradeButton}
              onClick={handleUpgrade}
              disabled={loading}
            >
              {loading ? 'Redirecting to PayFast…' : 'Upgrade Now'}
            </button>
            <button 
              className={styles.backButton}
              onClick={() => navigate('/Account')}
            >
              Back to Account
            </button>
          </div>

          <p className={styles.note}>
            <small>
              Secure payment powered by PayFast. Cancel anytime.
            </small>
          </p>
        </div>

        <div className={styles.testimonial}>
          <blockquote>
            "Realty Genie transformed our compliance process. Worth every cent!"
          </blockquote>
          <cite>— Principal, Leading Agency</cite>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
